import { useSelector } from 'react-redux';

export const useDataProviderAllowed = () => {
  const { user } = useSelector((state) => state.user);

  return user.superAdmin || user.impersonated || window.location.href.includes('https://localhost');
};
